import React, { useEffect, useState } from 'react'
import BarcodeGenerator from '@components/Barcode/index'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { clearOrderData } from '@slice/mainSlice'
import { generateImage } from '@utils/generateShapeImage'
import moment from 'moment'
import { numberWithSpacesIntl } from '@utils/numberWithSpaces'
import Oval from '@assets/images/Shapes/Pencil.png'
import renderServiceTypeSvg from '@utils/renderServiceTypeSvg'
import { useLocation } from 'react-router-dom'
import { http } from '@services/http'
import { useQuery } from '@tanstack/react-query'

const SalesMiniDashboard = () => {
	const dispatch = useDispatch()
	const { ordersPage } = useSelector((state) => state.main)

	const location = useLocation()

	const docEntry = window.location.search.split('docEntry=')[1]

	console.log('docEntry', docEntry)

	const fetchMiniDashboard = async ({ queryKey }) => {
		const [_, docEntry] = queryKey

		try {
			const url = `api/salesdata/document-item-details?docEntry=${docEntry}`

			const { data } = await http.get(url)
			return data
		} catch (error) {}
	}

	// const [data, setData] = useState(null)
	const [paidToDate, setPaidToDate] = useState(0)

	// useEffect(() => {
	// 	setTimeout(() => {
	// 		window.print()
	// 	}, 1000)
	// }, [])

	// useEffect(() => {
	// 	const storedData = sessionStorage.getItem('salesMiniDashboardData')
	// 	if (storedData) {
	// 		setData(JSON.parse(storedData))
	// 		const data = JSON.parse(storedData)
	// 		const debtDocument = +data?.paidTotal * +data?.docRate

	// 		setPaidToDate(debtDocument)

	// 		console.log('salesMiniDashboardData', data)
	// 	}
	// }, [])

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['miniDashboard', docEntry],
		queryFn: fetchMiniDashboard,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	useEffect(() => {
		console.log('ordersPage =', ordersPage)
		return () => {
			dispatch(clearOrderData())
		}
	}, [dispatch])

	return (
		<div className="p-2 bg-white text-black font-semibold   font-sans">
			<div className="border-b ">
				<div className="flex justify-between items-center">
					<div className="flex flex-col gap-2">
						<p className="font-semibold  text-2xl text-center">
							BUYURTMA № {data[0]?.docNum}
						</p>
						<div className="text-sm">
							<span className="font-semibold ">Menejer:</span>{' '}
							{data[0]?.slpName}
						</div>
					</div>
					<div>
						<BarcodeGenerator
							docNum={data[0]?.docNum}
							height={35}
							width={1.5}
							fontSize={14}
							margin={20}
						/>
					</div>
				</div>

				<div className="flex items-center gap-5 justify-between mb-5 text-sm w-full">
					<div className=" flex flex-col gap-2">
						<p className="font-semibold ">
							Buyurtma haqida ma'lumot
						</p>
						<p>
							<span>Sana: </span>
							{moment(data[0]?.docDate).format('DD.MM.YYYY')}
							<span> / Muddati:</span>{' '}
							{moment(data[0]?.docDueDate).format('DD.MM.YYYY')}
						</p>
					</div>
					<div className="flex flex-col gap-2">
						<p className="mt-2 font-semibold  text-right">
							Xaridor haqida ma'lumot
						</p>
						<p className="text-right">
							<span>F.I.SH: </span>
							{data[0]?.cardName}
						</p>
					</div>
				</div>
			</div>

			<div className="mb-6">
				<table className="w-full border-collapse border border-gray-400 text-sm">
					<thead>
						<tr className="print:bg-[#364152]  text-white font-semibold  text-[12px] bg-[#364152]  print-bg-color">
							<th className="border border-gray-400 px-2 py-1">
								№
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Mahsulot nomi
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Razmer
							</th>

							<th className="border border-gray-400 px-2 py-1">
								Soni
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Kesish
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Charxlash
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Teshish
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Kalit
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Gravirovka Piskastroy Paket
							</th>
							<th className="border border-gray-400 px-2 py-1">
								OTK
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Pogruzka
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Tayyor bolganlar soni
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Yuklab yuborilgan soni
							</th>
							<th className="border border-gray-400 px-2 py-1">
								Yuborish kerak
							</th>
						</tr>
					</thead>
					<tbody>
						{data?.map((item, idx) => {
							const openQuantitySon =
								item.openQty /
								((item.width * +item.height) / 1000000)

							const getServiceCount = (modalName) =>
								item.documentLines?.find(
									(line) => line.modal === modalName,
								)?.serviceCount || 0

							return (
								<tr
									className="font-semibold text-sm print-bg-color"
									key={item.itemCode}
								>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{idx + 1}
									</td>
									<td className="border border-gray-400 px-2 py-1">
										{item.dscription}
									</td>
									<td className="border border-gray-400 px-2 py-1">
										{`${item.width} x ${item.height} `}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{new Intl.NumberFormat('fr-FR').format(
											item.plannedQuantity,
										)}
									</td>

									<td className="border border-gray-400 px-2 py-1 text-center">
										{getServiceCount('Kesish')}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{getServiceCount('Charxlash')}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{getServiceCount('Teshish')}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{getServiceCount('Kalit')}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{getServiceCount(
											'Gravirovka|Piskastroy|Paket',
										)}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{getServiceCount('Otk')}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{getServiceCount('Pogruzka')}
									</td>

									<td className="border border-gray-400 px-2 py-1 text-center">
										{new Intl.NumberFormat('fr-FR').format(
											item.readyCount,
										)}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{new Intl.NumberFormat('fr-FR').format(
											item.plannedQuantity -
												(openQuantitySon || 0),
										)}
									</td>
									<td className="border border-gray-400 px-2 py-1 text-center">
										{new Intl.NumberFormat('fr-FR').format(
											item.readyCount || 0,
										)}
									</td>
								</tr>
							)
						})}
					</tbody>

					{/* <tfoot>
								<tr className="print:bg-[#364152] text-white font-semibold  text-sm bg-[#364152]  print-bg-color">
									<td
										className="border border-gray-400 px-2 py-1 text-end font-semibold "
										colSpan={3}
									>
										{`Jami: ${new Intl.NumberFormat(
											'fr-FR',
										).format(
											data?.documentLines
												.filter(
													(item) =>
														item.u_Produkt !==
															null &&
														item.u_ItemGroup ===
															'Service',
												)
												.reduce(
													(total, item) =>
														total + item.lineTotal,
													0,
												),
										)} ${data?.documentLines[0].currency}`}
									</td>
								</tr>
							</tfoot> */}
				</table>
			</div>
		</div>
	)
}

export default SalesMiniDashboard
